import type { ComponentTheme } from '../types/component-theme';

import { BrDataTableVariants } from './constants/br-data-table';
import { dataCollectionFooterInfoStyles } from '../shared-styles';

const thStyles = 'px-4 py-3.5 text-left text-[0.88rem] font-semibold';
const tdStyles = 'whitespace-normal wrap-break-word border-b';

export default {
    slots: {
        root: 'flex h-full min-h-0 flex-col',
        tableFrame: 'min-h-0 flex-1 overflow-hidden',
        tableScroll:
            'h-full overflow-auto rounded-lg border border-(--neutral-border) ' +
            'shadow-[0_0.063rem_0.125rem_rgba(0,0,0,0.05)]',
        tableRoot: 'min-w-full overflow-visible',
        base: 'min-w-full table-fixed border-separate border-spacing-0',
        thead: 'bg-(--status-unknown-bg)',
        tbody: 'bg-white',
        tr: 'transition-colors duration-150 hover:bg-[rgba(229,231,235,0.55)]',
        separator: 'bg-(--slate-muted-alpha-20)',
        th: `whitespace-nowrap ${thStyles} text-(--text-ink)`,
        td: `${tdStyles} border-(--neutral-border) p-4 text-[0.88rem] text-(--text-medium)`,
        empty: 'px-6 py-14 text-center text-[0.88rem] text-(--text-medium)',
        loading: 'px-6 py-14 text-center',
        footer: 'grid items-center border-t border-gray-200/60 p-4 text-[0.85rem] text-gray-500',
        footerInfo: dataCollectionFooterInfoStyles,
        footerPagination: 'flex justify-center pt-4'
    },
    variants: {
        variant: {
            [BrDataTableVariants.Default]: {},
            [BrDataTableVariants.Glass]: {
                tableScroll:
                    'h-full overflow-auto rounded-none border-0 bg-transparent font-(family-name:--primary-font) ' +
                    'shadow-none [scrollbar-color:var(--gray-alpha-30)_transparent] scrollbar-thin ' +
                    '[&::-webkit-scrollbar]:size-1.5 [&::-webkit-scrollbar-thumb]:rounded-[0.188rem] ' +
                    '[&::-webkit-scrollbar-thumb]:bg-(--gray-alpha-30) ' +
                    '[&::-webkit-scrollbar-thumb:hover]:bg-(--gray-alpha-50) ' +
                    '[&::-webkit-scrollbar-track]:bg-transparent',
                thead: 'bg-transparent',
                tbody: 'bg-transparent',
                tr:
                    'bg-transparent transition-colors duration-150 hover:bg-(--white-alpha-45) ' +
                    'hover:shadow-[inset_0_0_0_0.063rem_rgba(255,255,255,0.15)]',
                th:
                    'whitespace-nowrap border-b border-[rgba(209,213,219,0.5)] bg-transparent ' +
                    thStyles +
                    ' text-(--text-soft) first:pl-6 last:pr-6',
                td:
                    tdStyles +
                    ' border-[rgba(180,186,194,0.35)] p-4 text-[0.88rem] text-(--text-soft) first:pl-6 ' +
                    'first:font-semibold first:text-(--text-deep) last:pr-6',
                footer:
                    'grid min-w-0 items-center border-t border-(--neutral-border-soft) bg-transparent px-0 py-4 ' +
                    'sm:px-6 text-[0.85rem] text-gray-500',
                footerPagination: 'flex min-w-0 justify-center pt-4'
            }
        },
        sidebarOpen: {
            true: {
                footer: 'wide:grid-cols-2',
                footerInfo: 'wide:text-start',
                footerPagination: 'wide:justify-end wide:pt-0'
            },
            false: {
                footer: 'desk:grid-cols-2',
                footerInfo: 'desk:text-start',
                footerPagination: 'desk:justify-end desk:pt-0'
            }
        },
        striped: {
            true: {
                base: '[&_tbody_tr:nth-of-type(odd)]:bg-[rgba(249,250,251,0.5)]'
            }
        }
    }
} satisfies ComponentTheme;
